function handleInfoWrapperClick(event) {
  const target = event.target;
  if (!target.closest('[data-target]')) return;
  const infoId = target.closest('[data-target]').getAttribute('data-target');
  const additionalInfo = document.getElementById(infoId);
  const drawer = document.querySelector('cart-drawer');
  document.querySelectorAll('.drawer__additional-info').forEach((info) => {
    info.classList.remove('active');
  });
  if (additionalInfo && !additionalInfo.classList.contains('active')) {
    additionalInfo.classList.add('active');
    drawer.classList.add('drawer--extended');
  } else {
    if (additionalInfo) additionalInfo.classList.remove('active');
    if (drawer) drawer.classList.remove('drawer--extended');
  }
}

function handleDrawerClose() {
  closeDrawer();
}

function handleDrawerBack() {
  const drawer = document.querySelector('cart-drawer');
  const additionalInfo = document.querySelectorAll('.drawer__additional-info');
  additionalInfo.forEach((info) => info.classList.remove('active'));
  if (drawer) drawer.classList.remove('drawer--extended');
}

function initializeCartListeners() {
  const cartInfoWrapper = document.querySelector('.cart__info-wrapper');
  if (cartInfoWrapper) {
    cartInfoWrapper.removeEventListener('click', handleInfoWrapperClick);
    cartInfoWrapper.addEventListener('click', handleInfoWrapperClick);
  }

  const closeBtn = document.querySelector('.drawer__close');
  if (closeBtn) {
    closeBtn.removeEventListener('click', handleDrawerClose);
    closeBtn.addEventListener('click', handleDrawerClose);
  }

  const overlay = document.querySelector('.cart-drawer__overlay');
  if (overlay) {
    overlay.removeEventListener('click', handleDrawerClose);
    overlay.addEventListener('click', handleDrawerClose);
  }

  const drawerBackButton = document.querySelector('.drawer__back');
  if (drawerBackButton) {
    drawerBackButton.removeEventListener('click', handleDrawerBack);
    drawerBackButton.addEventListener('click', handleDrawerBack);
  }
}

function closeDrawer() {
  const drawer = document.querySelector('cart-drawer');
  const additionalInfo = document.querySelectorAll('.drawer__additional-info');
  additionalInfo.forEach((info) => info.classList.remove('active'));
  if (drawer) drawer.classList.remove('drawer--extended');
}

// Observe changes to the cart drawer in order to reattach
// event listeners when its contents are replaced dynamically
const cartDrawer = document.querySelector('cart-drawer');

const observer = new MutationObserver(() => {
  initializeCartListeners();
});

if (cartDrawer) {
  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
  });
}

// Initialize the listeners when the page loads
initializeCartListeners();
